import dynamic from 'next/dynamic';
import type { FC } from 'react';

import { useCarouselPictures } from '@/domains/productDiscovery/ArticleReviews/ArticlePictures.ducks';
import type { PicturesCarouselProps } from '@/domains/productDiscovery/ArticleReviews/modules/reviewsBlock/picturesCarousel/PicturesCarousel';

const Carousel = dynamic<PicturesCarouselProps>(
  () =>
    import(
      '@/domains/productDiscovery/ArticleReviews/modules/reviewsBlock/picturesCarousel/PicturesCarousel'
    ).then((module) => module.PicturesCarousel),
  {
    ssr: false,
    loading: () => <div style={{ height: 176 }} />,
  },
);

export const PicturesCarouselDynamic: FC = () => {
  const { pictures } = useCarouselPictures();

  if (!pictures?.length) return null;
  return <Carousel pictures={pictures} />;
};

PicturesCarouselDynamic.displayName = 'PicturesCarouselDynamic';
